import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { PrimaryButton } from '@shared/components/buttons';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { StepHeading } from './step-heading';

type CompleteProps = {
  storeId: string;
};

const AUTO_REDIRECT_MS = 5_000;

export function Complete({ storeId }: CompleteProps) {
  const navigate = useNavigate();
  const goToSessionsList = () =>
    navigate({ to: '/stores/$storeId/receiving', params: { storeId } });

  // biome-ignore lint/correctness/useExhaustiveDependencies: goToSessionsList is intentionally excluded; effect is keyed on storeId only
  useEffect(() => {
    const id = window.setTimeout(goToSessionsList, AUTO_REDIRECT_MS);

    return () => window.clearTimeout(id);
  }, [storeId]);

  return (
    <div className="flex flex-col gap-4" data-testid="receiving-complete">
      <div className="flex items-center gap-3">
        <CheckCircleIcon className="h-8 w-8 text-primary-600 shrink-0" aria-hidden="true" />
        <StepHeading>Receiving complete.</StepHeading>
      </div>
      <p className="text-base leading-relaxed text-gray-700">
        Your products are now in LiquorPOS. Returning to the receiving list in a moment…
      </p>
      <div className="mt-2 flex items-center justify-end gap-3">
        <PrimaryButton onClick={goToSessionsList}>Start another receiving</PrimaryButton>
      </div>
    </div>
  );
}
